import { render, staticRenderFns } from "./LayoutCMSContentDefault.vue?vue&type=template&id=5885433f"
var script = {}
import style0 from "./LayoutCMSContentDefault.vue?vue&type=style&index=0&id=5885433f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports